import request from '../utils/request';
import GlobalParameters from '../utils/globalParameters';

export async function securityQuestionsQuery(customer_id) {
    return request(`${GlobalParameters.website}/erams/api/cportal/security` , {method: 'get'});
}

